<template>
  <v-navigation-drawer 
    v-model="$store.state.drawer" 
    width="200" 
    app>
    <v-list>
      <v-list-tile 
        avatar 
        @click="navigate('kohde')">
        <v-list-tile-action>
          <v-icon>
            location_on
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Kohde
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile 
        avatar 
        @click="navigate('oma')">
        <v-list-tile-action>
          <v-icon>
            store
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Oma Varasto
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
	methods: {
		navigate(route) {
			this.$store.state.drawer = false
			this.$store.dispatch('navigate', { to: route })
		}
	}
}
</script>
